import process1Img from "../assets/images/process1.png";
import process2Img from "../assets/images/process2.png";
import process3Img from "../assets/images/process3.png";

export const timelineGroups = [
  {
    image: process1Img,
    align: "right",
    items: [
      {
        weeks: "DAYS 01 — 02",
        title: "Pick Your Design",
        description: "I will start by choosing a website style that fits your business. Once you have picked one, I will go over the pages and changes you need.",
        align: "right"
      },
      {
        weeks: "DAYS 04 — 05",
        title: "Send Your Content",
        description: "Send over your logo, photos, text, videos, contact details, and anything else you want on the site. I will take care of putting everything in the right place.",
        align: "right"
      }
    ]
  },
  {
    image: process2Img,
    align: "left",
    items: [
      {
        weeks: "DAYS 06 — 08",
        title: "Make It Yours",
        description: "This is where the website starts looking like your business. I will update the colors, fonts, images, content, and layout to match your brand.",
        align: "left"
      },
      {
        weeks: "DAYS 09 — 10",
        title: "Mobile & Final Details",
        description: "I will make sure everything works properly on phones, tablets, and desktops. Forms, buttons, links, maps, and other small details will also be checked.",
        align: "left"
      }
    ]
  },
  {
    image: process3Img,
    align: "right",
    items: [
      {
        weeks: "DAYS 11 — 12",
        title: "Your Review",
        description: "You will get a chance to look through the finished website and let me know if anything needs changing. I will make the final adjustments from your feedback.",
        align: "right"
      },
      {
        weeks: "DAYS 13 — 15",
        title: "Ready to Go Live",
        description: "Once everything looks good, I will take care of the final checks, connect your domain, set up HTTPS, and publish the website.",
        align: "right"
      }
    ]
  }
];
